import { render, staticRenderFns } from "./mail_whitelist.vue?vue&type=template&id=099ad724"
import script from "./mail_whitelist.vue?vue&type=script&lang=js"
export * from "./mail_whitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports